export const checkIfProductIsClicked = (idProductInMenu, idProductClickedOn) => {
    return idProductInMenu === idProductClickedOn ? true : false;
  }